"use client";

import React from "react";

import CustomImage from "@/components/shared/CustomImage";
import Title from "@/components/shared/Title";
import { useLanguage } from "@/contexts/LanguageContext";
import type { Home, Media } from "@/payload-types";
import getImageUrl from "@/utils/getImageUrl";
import type { PayLoadData } from "@/utils/payloadUtil";

const Services = ({ home }: { home: PayLoadData<Home> | undefined }) => {
  const { language } = useLanguage();

  return (
    <section id="services" className="bg-white">
      <div className="container mx-auto px-4">
        <Title
          title={home?.[language]?.services?.titleService || ""}
          desc={home?.[language]?.services?.descService || ""}
        />
        <div className="mt-12 flex max-w-full flex-wrap justify-center gap-12 md:mx-auto md:max-w-4xl lg:gap-16 xl:max-w-6xl xl:gap-32">
          {home?.[language]?.services?.listService?.map((item, idx) => (
            <div
              key={idx}
              className="flex max-w-lg items-start gap-5 text-left md:gap-10"
            >
              <div className="rounded-full bg-primary-50 p-4 text-primary-500 md:p-8">
                <div className="relative size-10 text-primary-500 md:size-12">
                  <CustomImage
                    src={getImageUrl(item?.icon)}
                    alt={(item.icon as Media).alt || "icon-srevice"}
                    fill
                    priority
                    className="size-full object-contain"
                  />
                </div>
              </div>
              <div>
                <h3 className="mb-2 text-lg font-semibold text-primary-700">
                  {item?.name || ""}
                </h3>
                <p className="text-base text-gray-600">{item?.desc || ""}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
